import React from 'react'

export const ColsContext = React.createContext(null)